// Button's focus ring (design.md › Buttons, Input): 3px brand-border.
export const OPUS_AGENT_FOCUS_RING_CLASSNAME =
  "focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-brand-border";
